import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaLinkedinIn,
  FaPinterestP,
} from "react-icons/fa";

const SocialShare = [
  { Social: <FaFacebookF />, link: "https://www.facebook.com/leadgiants" },
  { Social: <FaTwitter />, link: "https://twitter.com/leadgiants" },
  { Social: <FaInstagram />, link: "https://www.instagram.com/leadgiants/" },
  { Social: <FaLinkedinIn />, link: "https://www.linkedin.com/in/edcodehead/" },
  { Social: <FaPinterestP />, link: "www.pinterest.com/leadgiants" },
];

const Social = () => {
  return (
    <div className="nav social-icons" style={{ justifyContent: 'center' }}>
      {SocialShare.map((val, i) => (
        <a key={i} href={`${val.link}`} rel="noreferrer" target="_blank" style={{ marginRight: 12 }}>
          {val.Social}
        </a>
      ))}
    </div>
  );
};

export default Social;
